module.exports = __webpack_public_path__ + "img/Support-skill-333.298df16a.png";